import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {
  BehaviorTrackerWrapperComponent
} from "./screens/wrapper/behavior-tracker-wrapper.component";
import {
  BehaviourTrackerSummaryScreenComponent
} from "./screens/summary-screen/summary-screen.component";
import {
  BehaviorTrackerDetailsScreenComponent
} from "./screens/details-screen/details-screen.component";
import {SharedModule} from "../../shared/shared.module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/behavior-tracker.reducer";
import {EffectsModule} from "@ngrx/effects";
import {BehaviorTrackerEffects} from "./core/behavior-tracker.effects";
import {
  WeekListTableComponent
} from './components/week-list-table/week-list-table.component';
import {MatExpansionModule} from "@angular/material/expansion";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {ResourcesHubModule} from "../resources-hub/resources-hub.module";
import {
  ResourceCardComponent
} from './components/resource-card/resource-card.component';
import {
  DaySelectorComponent
} from './components/day-selector/day-selector.component';
import {
  DailyScorePanelComponent
} from './components/daily-score-panel/daily-score-panel.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import { RedLightChartComponent } from './components/red-light-chart/red-light-chart.component';
import { PhysicalActivityChartComponent } from './components/physical-activity-chart/physical-activity-chart.component';
import { ScreenTimeChartComponent } from './components/screen-time-chart/screen-time-chart.component';
import { BehaviourTrackerDetailScreenShimmerLoaderComponent } from './screens/behaviour-tracker-detail-screen-shimmer-loader/behaviour-tracker-detail-screen-shimmer-loader.component';


@NgModule({
  declarations: [
    BehaviorTrackerWrapperComponent,
    BehaviourTrackerSummaryScreenComponent,
    BehaviorTrackerDetailsScreenComponent,
    WeekListTableComponent,
    ResourceCardComponent,
    DaySelectorComponent,
    DailyScorePanelComponent,
    RedLightChartComponent,
    PhysicalActivityChartComponent,
    ScreenTimeChartComponent,
    BehaviourTrackerDetailScreenShimmerLoaderComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.behavior-tracker', reducer),
    EffectsModule.forFeature(
      [BehaviorTrackerEffects]
    ),
    MatExpansionModule,
    InfiniteScrollModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSortModule,
    ResourcesHubModule,
    MatTooltipModule,
  ],
  providers: [
    DecimalPipe
  ]
})
export class BehaviorTrackerModule {
}
